import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useHistory, Route, Switch, Redirect } from 'react-router-dom';
import * as R from 'ramda';
import $ from 'jquery';
import { useDispatch } from 'react-redux';
import removeAccents from 'remove-accents';

import { fetchInvoices, GetUsersByPartnerIdAndEtablissementId, resetPassword } from '../../actions/partner/partner';
import { FacilitaMain } from './main';
import { getUserRepresentatives } from '../../actions/backoffice/partners';
import { LoadingState } from '../../_common/loadingState';


export const Facilita = ({ partnerState, etablissement, partner, isPartner }) => {

	const dispatch = useDispatch();
	const searchQuery = useLocation();
	const history = useHistory();
	const pageQuery = new URLSearchParams(searchQuery.search);

	let page = pageQuery.get('page');
	let search = pageQuery.get('search');
	let type = pageQuery.get('type');
	let startDate = pageQuery.get('startDate');
	let endDate = pageQuery.get('endDate');
	let sortBy = pageQuery.get('sortBy');
	let sortDesc = pageQuery.get('sortDesc');

	page = R.isNil(page) ? 1 : parseInt(page);
	search = R.isNil(search) ? "" : search;
	type = R.isNil(type) ? "facilita" : type;
	startDate = R.isNil(startDate) ? "" : startDate;
	endDate = R.isNil(endDate) ? "" : endDate;
	sortBy = R.isNil(sortBy) ? "creationDate" : sortBy;
	sortDesc = R.isNil(sortDesc) ? "true" : sortDesc;

	const [pageSearch, setPageSearch] = useState(search);
	const [usersWithRepresentatives, setUsersWithRepresentatives] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [date, setDate] = useState({
		startDate: !R.isEmpty(startDate) ? new Date(startDate) : undefined,
		endDate: !R.isEmpty(endDate) ? new Date(endDate) : undefined
	});

	const renderRef = useRef(false);
	const renderDateRef = useRef(false);



	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip('update');
	}, []);

	useEffect(() => {
		if (isNaN(page) || page === 0) {
			history.push("/partner/facilita");
			return;
		}

		//pageNumber, searchTerm,role, sortByTerm, sortDesc
		const etablissementId = !R.isNil(etablissement) ? etablissement.id : null;
		dispatch(GetUsersByPartnerIdAndEtablissementId(partnerState.partner.id, etablissementId, page, pageSearch, type, startDate, endDate, sortBy, sortDesc));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchQuery.search, history.location]);

	let timer = null;
	useEffect(() => {

		if (!renderRef.current) {
			renderRef.current = true;
			return;
		};

		if (R.isEmpty(pageSearch)) {
			history.push(`/partner/facilita?page=${1}${type !== "" ? "&type=" + type : ""}${startDate !== "" ? "&startDate=" + startDate : ""}${endDate !== "" ? "&endDate=" + endDate : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "" ? "" : sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
			return;
		}

		clearTimeout(timer);
		timer = setTimeout(() => {
			dispatch(GetUsersByPartnerIdAndEtablissementId(partnerState.partner.id, etablissement.id, page, pageSearch, type, startDate, endDate, sortBy, sortDesc));
		}, 1000);


		return () => clearTimeout(timer);

		// eslint-disable-next-line 
	}, [pageSearch]);

	useEffect(() => {

		if (!renderDateRef.current) {
			renderDateRef.current = true;
			return;
		};

		if (!R.isEmpty(date.startDate) && !R.isNil(date.startDate) && !R.isNil(date.endDate) && !R.isEmpty(date.endDate)) {
			history.push(`/partner/facilita?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${type !== "" ? "&type=" + type : ""}${"&startDate=" + (date.startDate.toISOString().slice(0, 10))}${"&endDate=" + (date.endDate.toISOString().slice(0, 10))}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "" ? "" : sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
			return;

		} else if (!R.isEmpty(date.startDate) && !R.isNil(date.startDate)) {
			history.push(`/partner/facilita?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${type !== "" ? "&type=" + type : ""}${"&startDate=" + (date.startDate.toISOString().slice(0, 10))}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "" ? "" : sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
			return;

		} else if (!R.isNil(date.endDate) && !R.isEmpty(date.endDate)) {
			history.push(`/partner/facilita?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${type !== "" ? "&type=" + type : ""}${"&endDate=" + (date.endDate.toISOString().slice(0, 10))}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "" ? "" : sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
			return;

		} else {
			history.push(`/partner/facilita?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${type !== "" ? "&type=" + type : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "" ? "" : sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
		}

		// eslint-disable-next-line 
	}, [date]);


	useEffect(() => {

		// fetch all representatives by user id

		if (R.isNil(partnerState.users) || R.isEmpty(partnerState.users)) {
			setUsersWithRepresentatives([]);
			return;
		}
		setIsLoading(true);

		let userPromises = [];
		partnerState.users.forEach(user => {
			userPromises.push(getUserRepresentatives(user.id));
		});

		Promise.all(userPromises).then((representatives) => {

			representatives = representatives.filter(u => !R.isEmpty(u)).map(userRepresent => userRepresent.filter(r => r.isMainRepresentative)[0]);

			let users = partnerState.users.map(u => {

				let representative = representatives.find(r => r.userId === u.id);

				if (!R.isNil(representative)) {

					u.mainRepresentative = {
						id: representative.id,
						firstName: representative.firstName,
						lastName: representative.lastName
					};

					return u;
				}


				return u;
			});

			setIsLoading(false);
			setUsersWithRepresentatives(users);
		}).catch(error => {
			setIsLoading(false);
		});


	}, [partnerState.users]);


	const routerQuery = {
		page,
		search,
		type,
		sortBy,
		sortDesc,
		endDate,
		startDate,
		date
	};


	// if (R.isNil(usersWithRepresentatives)) return (<LoadingState />);


	return (
		<Switch>
			<Route exact path="/partner/facilita" >
				<FacilitaMain partner={partner} etablissement={etablissement} users={usersWithRepresentatives} isLoadingRepresentatives={isLoading} partnerState={partnerState} routerQuery={routerQuery} pageSearch={pageSearch} setPageSearch={setPageSearch} date={date} setDate={setDate} isPartner={isPartner} />
			</Route>
			{/* <Route path="/partner/anticipa/:user" component={ClientsDetail} /> */}
			<Route render={() => {
				return <Redirect exact to="/partner/facilita" />;
			}} />
		</Switch>
	);
};